import { HOST } from "../config";
import { httpGet } from "../contexts/AppContext";
import { ProductiveUnit } from "../models/productiveUnitModels";

const URL_PUBLIC = 'public/';

export async function getProductiveUnitByUid(uid: string): Promise<ProductiveUnit> {
    return httpGet<ProductiveUnit>(HOST + URL_PUBLIC + 'productiveUnit/' + uid);
}